module.exports = __webpack_public_path__ + "img/l2.8f577d74.jpg";